






import { Component, Vue } from 'vue-property-decorator';
import ModuleModal from '@/components/modals/ModuleModal.vue';
import AddModule from '@/components/modals/AddModule.vue';
import CreateClassroom from '@/components/modals/CreateClassroom.vue';
import DeleteClassroom from '@/components/modals/DeleteClassroom.vue';
import ShareClassroomUrl from '@/components/modals/ShareClassroomUrl.vue';
import CreateTeacher from '@/components/modals/CreateTeacher.vue';
import EditClassroomModuleName from '@/components/modals/EditClassroomModuleName.vue';
import { IModule } from '@/models/Modules';

@Component({
  components: {
    ModuleModal,
    AddModule,
    CreateClassroom,
    DeleteClassroom,
    ShareClassroomUrl,
    CreateTeacher,
    EditClassroomModuleName,
  },
})
export default class ModalContainer extends Vue {
  showModal = false;
  modalType: any = null;
  data: any = null;

  mounted() {
    this.$parent.$on('create-module', () => {
      this.modalType = 'module-modal';
      this.showModal = true;
      this.data = null;
    });

    this.$parent.$on('edit-module', (module: IModule) => {
      this.modalType = 'module-modal';
      this.showModal = true;
      this.data = module;
    });

    this.$parent.$on('add-module', () => {
      this.modalType = 'add-module';
      this.showModal = true;
    });

    this.$parent.$on('create-classroom', () => {
      this.modalType = 'create-classroom';
      this.showModal = true;
    });

    this.$parent.$on('delete-classroom', () => {
      this.modalType = 'delete-classroom';
      this.showModal = true;
    });

    this.$parent.$on('share-classroom-url', () => {
      this.modalType = 'share-classroom-url';
      this.showModal = true;
    });

    this.$parent.$on('create-teacher', () => {
      this.modalType = 'create-teacher';
      this.showModal = true;
    });

    this.$parent.$on('edit-classroom-module-name', (data: any) => {
      this.modalType = 'edit-classroom-module-name';
      this.showModal = true;
      this.data = data;
    });

    this.$on('close-modal', () => {
      this.closeModal();
    });

    window.addEventListener('keydown', this.handleKeyEvent);
  }

  beforeDestroy() {
    window.addEventListener('keydown', this.handleKeyEvent);
  }

  public handleKeyEvent(evt: KeyboardEvent) {
    if (evt.code === 'Escape' && this.showModal) {
      this.closeModal();
    }
  }

  closeModal() {
    this.showModal = false;
  }
}
